(ns ui.components.badge.zapkit-styles)

;; ----------------------------------------------------------------------------
;; AUTO-GENERATED FILE — DO NOT EDIT MANUALLY.
;; Regenerate via: scripts/convert_zapkit_json.bb <source>.json <output-dir-or-file>
;; (run from the project root directory).
;; Source: zapkit-components/src/components/Badge/styles.json
;; Source commit: 7b54b099d2a80226b6558baf652e84af7b947d52
;; ----------------------------------------------------------------------------

(def badge
  {:root
   {:base
    "tw2-inline-flex tw2-items-center tw2-justify-center tw2-gap-badge-gap tw2-px-badge-px tw2-py-badge-py tw2-rounded-badge tw2-font-sans tw2-text-label-sm",
    :variant
    {:primary "tw2-bg-badge-primary-bg tw2-text-badge-primary-text",
     :secondary
     "tw2-bg-badge-secondary-bg tw2-text-badge-secondary-text",
     :destructive
     "tw2-bg-status-lost-badge-bg tw2-text-status-lost-badge-text",
     :success
     "tw2-bg-status-success-badge-bg tw2-text-status-success-badge-text",
     :on-hold
     "tw2-bg-status-on-hold-badge-bg tw2-text-status-on-hold-badge-text"},
    :compound-variants [],
    :default-variants {:variant "primary"}},
   :close
   {:base
    "tw2-flex-shrink-0 tw2-rounded tw2-transition-colors focus-visible:tw2-outline-none focus-visible:tw2-outline-2 focus-visible:tw2-outline-offset-1 focus-visible:tw2-outline-current",
    :variant
    {:primary "tw2-text-badge-primary-text hover:tw2-opacity-80",
     :secondary "tw2-text-badge-secondary-text hover:tw2-opacity-80",
     :destructive "tw2-text-status-lost-badge-text hover:tw2-opacity-80",
     :success "tw2-text-status-success-badge-text hover:tw2-opacity-80",
     :on-hold "tw2-text-status-on-hold-badge-text hover:tw2-opacity-80"},
    :compound-variants [],
    :default-variants {:variant "primary"}},
   :close-icon
   {:base "tw2-w-3 tw2-h-3",
    :compound-variants [],
    :default-variants {}},
   :_meta
   {:tokens
    ["badge-primary-bg"
     "badge-primary-text"
     "badge-secondary-bg"
     "badge-secondary-text"
     "label-sm-font-size"
     "label-sm-font-weight"
     "label-sm-line-height"
     "radius-badge"
     "spacing-badge-gap"
     "spacing-badge-px"
     "spacing-badge-py"
     "status-lost-badge-bg"
     "status-lost-badge-text"
     "status-on-hold-badge-bg"
     "status-on-hold-badge-text"
     "status-success-badge-bg"
     "status-success-badge-text"],
    :generated-from "src/components/Badge/Badge.styles.ts"}})
